import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { connect } from "react-redux";
import { getSchema } from "../../actions";
import { getGymnasts } from "../../actions";
import { setTeamFilter } from "../../actions";
import { setYearFilter } from "../../actions";
import { setGymnastFilter } from "../../actions";

class NavBoxes extends Component {
  componentDidMount() {
    let params = this.props.match.params;
    let props = this.props;

    let team = params.tid !== undefined ? Number(params.tid) : props.teamFilter;
    let year = params.year !== undefined ? Number(params.year) : props.yearFilter;
    let gymnast = params.gid !== undefined ? Number(params.gid) : props.gymnastFilter;
    console.log(year);
    if(params.tid === undefined){
      if (typeof(Storage) !== "undefined") {
        if(localStorage.lastTeamIDGA) {
          team = localStorage.lastTeamIDGA;
        } else {
          team = 2;
        }
      }
    } else {
      team = Number(params.tid);
    }
    if(this.props.location.pathname === '/'){
      let url = '/dashboard/'+year+'/'+team;
      this.props.history.replace(url);
    }
    //this.props.getSchema({ team: team, year: year });
    this.props.getGymnasts({ team: team, year: year, gymnast: gymnast });
  }
  componentDidUpdate(prevProps) {
    //if filters are set
    if(/*Number(prevProps.gymnastFilter) !== 0 && **SEEMS LIKE NOT NEEDED AND CAUSING ISSUE**/Number(prevProps.yearFilter) !== 0 && Number(prevProps.teamFilter !== 0)){

      let params = this.props.match.params;
      let props = this.props;

      if(Number(params.tid) !== Number(props.teamFilter)
        || Number(params.year) !== Number(props.yearFilter)){

        let team = params.tid !== undefined ? Number(params.tid) : props.teamFilter;
        let year = params.year !== undefined ? Number(params.year) : props.yearFilter;
        let gymnast = params.gid !== undefined ? Number(params.gid) : props.gymnastFilter;

        //if(Number(params.year) !== Number(props.yearFilter)){
        //  this.props.getSchema({ team: team, year: year });
        //}
        this.props.getGymnasts({ team: team, year: year, gymnast: gymnast });

      } else if(JSON.stringify(prevProps.gymnasts) !== JSON.stringify(props.gymnasts) && prevProps.gymnastFilter !== props.gymnastFilter){
        var gfilter = '';
        let page = params.page;
        if(page === 'ch_consistency_i' || page === 'gymnast'){
          gfilter = `/${props.gymnastFilter}`;
        }
        this.props.history.replace(`/${page}/${this.props.yearFilter}/${this.props.teamFilter}${gfilter}`);
      } else if((Number(params.gid) !== Number(props.gymnastFilter)) /*&& this.props.match.params.gid !== undefined*/){
        if(params.gid !== undefined){
          this.props.setGymnastFilter(params.gid);
        }
      }
    }
  }

  getNavBoxes() {
    if(this.props.match.params.page !== undefined){
      let dashboard;
      if(this.props.match.params.page === 'dashboard'){
        dashboard = '';
      } else {
        dashboard = '_grey';
      }
      let teamRankings = this.props.match.params.page === "ch_team_rankings" ? '' : '_grey';
      let teamConsistency = this.props.match.params.page === "ch_consistency_t" ? '' : '_grey';
      let individualConsistency = this.props.match.params.page === "ch_consistency_i" ? '' : '_grey';
      let mpv = this.props.match.params.page === "ch_mvp" ? '' : '_grey';
      let impactDifference = this.props.match.params.page === "ch_impact_diff" ? '' : '_grey';
      let topScores = this.props.match.params.page === "ch_top_scores" ? '' : '_grey';
      let lineupFrequency = this.props.match.params.page === "ch_lineup_freq" ? '' : '_grey';
      //let fullTeamStats = this.props.match.params.page === "ch_full_team_stats" ? '' : '_grey';

      return <div className="small-12 columns">
        <Link className={"navbox nav-dashboard"+dashboard} to={"/dashboard/"+this.props.yearFilter+"/"+this.props.teamFilter}></Link>
        <Link className={"navbox nav-teamRankings"+teamRankings} to={"/ch_team_rankings/"+this.props.yearFilter+"/"+this.props.teamFilter}></Link>
        <Link className={"navbox nav-teamConsistency"+teamConsistency} to={"/ch_consistency_t/"+this.props.yearFilter+"/"+this.props.teamFilter}></Link>
        <Link className={"navbox nav-individualConsistency"+individualConsistency} to={"/ch_consistency_i/"+this.props.yearFilter+"/"+this.props.teamFilter+"/"+this.props.gymnastFilter}></Link>
        <Link className={"navbox nav-mpv"+mpv} to={"/ch_mvp/"+this.props.yearFilter+"/"+this.props.teamFilter}></Link>
        <Link className={"navbox nav-impactDifference"+impactDifference} to={"/ch_impact_diff/"+this.props.yearFilter+"/"+this.props.teamFilter}></Link>
        <Link className={"navbox nav-topScores"+topScores} to={"/ch_top_scores/"+this.props.yearFilter+"/"+this.props.teamFilter}></Link>
        <Link className={"navbox nav-lineupFrequency"+lineupFrequency} to={"/ch_lineup_freq/"+this.props.yearFilter+"/"+this.props.teamFilter}></Link>
      </div>;
    } else {
      return <div></div>;
    }
  }
  render() {
    return (
      <div className="row expanded">
        {this.getNavBoxes()}
        <div className="clearboth"></div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    teamFilter: state.main.teamFilter,
    yearFilter: state.main.yearFilter,
    gymnastFilter: state.main.gymnastFilter,
    gymnasts: state.main.gymnasts
  };
}

export default connect(mapStateToProps, { getSchema, getGymnasts, setTeamFilter, setYearFilter, setGymnastFilter })(NavBoxes);
